export default __webpack_public_path__ + "static/media/main_section10.139637bd.jpg";